import dashboardApi from '@custom/rtk-apis/dashboard/dashboard';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: "",
  result:null,
  msg: "",
  loading: false,
  error: ""
};

const dashboardSlice = createSlice({
  name: 'dashboardSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(dashboardApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(dashboardApi.fulfilled, (state, {payload}) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(dashboardApi.rejected, (state, {payload}) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default dashboardSlice.reducer;
